import { render, staticRenderFns } from "./31_main.vue?vue&type=template&id=6754da92&"
import script from "./31_main.vue?vue&type=script&lang=js&"
export * from "./31_main.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports